import { HTTP_METHODS } from "src/constants"
import { makeCall } from "src/helpers"
import { store } from "src/configureStore";
import {isEmpty} from "lodash"
import rootRoutes from "src/routes"

const formatResponse = (items) => items.map((item) => ({ 
  label: item.lotNumber, 
  value: item.id,
}))
export const lotScolaireUIHelper = (callback,param) => {
  const { token, headerTokenType, audience } = store.getState().common.auth || {}
  const tokenType = headerTokenType ? headerTokenType : 'Bearer'

  if (!param || isEmpty(param.toString())){
    callback([])
    return
  }
  const FETCH_ENDPOINT = "/api/lotDmsuList?speciality=:param".replace(':param',param)
  return new Promise((resolve, reject) =>
  makeCall(HTTP_METHODS.GET, FETCH_ENDPOINT, { _pagination: false }, { Authorization: `${tokenType} ${token}`, audience: `${audience}` } )
    .then(resp => resolve(callback(formatResponse(resp.data))))
    .catch((err) => { 
      if (err.response && err.response.status === 401){
        window.location.href=rootRoutes.logout.path
        return
      }
      return reject(callback([]) )})  
    
  )
}